import React, { useState } from "react";
import Footer from "../../components/Footer/Footer";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import { Link } from "react-router-dom";
import ApartmentIcon from "@mui/icons-material/Apartment";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import Branch from "../../components/Branch/Branch";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
function Branchs() {
  const [branchName, setBranchName] = useState("Главный офис");
  return (
    <div id="branchs">
      <div className="py-40 bg-[#3C31A2]">
        <h2
          data-aos="zoom-in"
          className="text-white leading-[50px] sm:leading-normal font-bold text-[50px] text-center"
        >
          Филиалы
        </h2>
      </div>
      <div className="py-6  bg-[#2F2C3D]">
        <div className="2xl:container px-5 mx-auto flex items-center space-x-1 text-white">
          <Link className="border-b-2  border-white" to={"/"}>
            Главный
          </Link>
          <DoubleArrowIcon style={{ inlineSize: "20px", blockSize: "20px" }} />
          <span>Филиалы</span>
        </div>
      </div>
      <div className="pt-10 pb-16 sm:pb-20 sm:pt-16 bg-[#262431]">
        <div className="2xl:container mx-auto px-5 flex flex-col sm:items-center space-y-12 xl:space-y-0 xl:items-start xl:flex-row justify-between">
          <div data-aos="zoom-in-up" className="space-y-4">
            <Branch
              regionName={"Tashkent"}
              setBranchName={setBranchName}
              branchName={branchName}
              office1={"Главный офис"}
              office2={"Ангрен Офис"}
              letMore={8}
              office3={"Аккурган Офис"}
              office4={"Aхангаран Офис"}
              office5={"Бука Офис"}
              office6={"Уртачирчик Офис"}
              office7={"Пскент Офис"}
              office8={"Олмалиқ Офис"}
            />
            <Branch
              regionName={"Навоий"}
              setBranchName={setBranchName}
              branchName={branchName}
              office1={"Навоий Офис"}
              office2={"Зарафшон Офис"}
              letMore={2}
            />
            <Branch
              regionName={"Хорезм"}
              setBranchName={setBranchName}
              branchName={branchName}
              office1={"Ургенч Офис"}
              office2={"Хазорасп Офис"}
              letMore={2}
              letSecound={true}
            />
          </div>
          <div data-aos="zoom-in-up" className="space-y-4 w-full xl:w-[33%] ">
            <h3
              data-aos="zoom-in-up"
              className="text-white flex items-center space-x-3 font-bold text-[22px] sm:text-[28px]"
            >
              <ApartmentIcon
                className="text-[#00C9DB]"
                style={{ inlineSize: "40px", blockSize: "40px" }}
              />
              <span>{branchName}</span>
            </h3>
            <p
              data-aos="zoom-in-up"
              className="text-white flex items-center space-x-3 text-[18px] sm:text-[20px]"
            >
              <LocationOnIcon
                className="text-[#00C9DB]"
                style={{ inlineSize: "40px", blockSize: "40px" }}
              />
              <span>
                {branchName === "Главный офис" &&
                  "г.Ташкент, Яккасарайский район, улица Бабура, дом 69/4"}
                {branchName === "Ангрен Офис" &&
                  "Ангрен сельскохозяйственный рынок 2 проход 2й этаж 77 магазин"}
                {branchName === "Аккурган Офис" &&
                  "Проход парка молодежи, ориентир задняя сторона Park Food"}
                {branchName === "Зарафшон Офис" &&
                  "Наваинская область Г.Зарафшан 1 микро район. дом 5, квартира 10, вход позади дома"}
                {branchName === "Ургенч Офис" && "Г. Ургенч ул. Пахлавон Махмуд дом 11 квартира 2"}
                {branchName === "Aхангаран Офис" && "Охангарон Шахар 3-микрорайон,Ориентир - задняя сторона  парфюмерного магазина Рузана"}
                {branchName === "Бука Офис" && "Bo'ka Adress"}
                {branchName === "Уртачирчик Офис" && "O'rtachirchiq Adress"}
                {branchName === "Пскент Офис" && "Piskent Adress"}
                {branchName === "Олмалиқ Офис" && "Olmaliq Adress"}
                {branchName === "Хазорасп Офис" && " Хазораспский район, улица Э.Гаязов 9"}
                {branchName === "Навоий Офис" && "г. Навои, улица А. Темура, 7 дом задняя сторона, напротив центрального базара"}
              </span>
            </p>
            <div
              data-aos="zoom-in-up"
              className="flex items-center space-x-3 text-white text-[15px] sm:text-[18px]"
            >
              <PhoneInTalkIcon
                className="text-[#00C9DB]"
                style={{ inlineSize: "40px", blockSize: "40px" }}
              />
              <div className="flex flex-col space-y-1">
                <a
                  className="space-x-3"
                  href={`tel:${branchName === "Главный офис" ? "+998712099060" : ""}${branchName === "Ангрен Офис" ? "+998943645790" : ""
                    } ${branchName === "Аккурган Офис" ? "+998770029068" : ""}${branchName === "Ургенч Офис" ? "+998993475757" : ""
                    }${branchName === "Aхангаран Офис" ? "+998772599061" : ""}${branchName === "Олмалиқ Офис" ? "+998772599062" : ""
                    }${branchName === "Навоий Офис" ? "+998933179959" : ""}`}
                >
                  <span>
                    {branchName === "Главный офис" ? "+998 71 209 90 60" : ""}
                    {branchName === "Ангрен Офис" ? "+998 94 364 57 90" : ""}{" "}
                    {branchName === "Аккурган Офис" ? "+998 77 002 90 68" : ""}
                    {branchName === "Ургенч Офис" ? "+998 99 347 57 57" : ""}
                    {branchName === "Aхангаран Офис" ? "+998 77 259 90 61" : ""}
                    {branchName === "Олмалиқ Офис" ? "+998 77 259 90 62" : ""}
                    {branchName === "Навоий Офис" ? "+998 93 317 99 59" : ""}
                  </span>
                </a>
                <a
                  className="space-x-3"
                  href={`tel:${branchName === "Главный офис" ? "+998712009096" : ""}${branchName === "Ангрен Офис" ? "++998770029069" : ""
                    }${branchName === "Зарафшон Офис" ? "+998942222244" : ""}${branchName === "Бука Офис" ? "+998770029064" : ""
                    }${branchName === "Уртачирчик Офис" ? "+998770029061" : ""}${branchName === "Пскент Офис" ? "+998770029061" : ""
                    }${branchName === "Хазорасп Офис" ? "+998937456054" : ""
                    }`}
                >
                  <span>
                    {branchName === "Главный офис" ? "+998 71 200 90 96" : ""}
                    {branchName === "Ангрен Офис" ? "+998 77 002 90 69" : ""}
                    {branchName === "Зарафшон Офис" ? "+998 94 222 22 44" : ""}
                    {branchName === "Бука Офис" ? "+998 77 002 90 64" : ""}
                    {branchName === "Уртачирчик Офис" ? "+998 77 002 90 61" : ""}
                    {branchName === "Пскент Офис" ? "+998 77 002 90 61" : ""}
                    {branchName === "Хазорасп Офис" ? "+998 93 745 60 54" : ""}
                  </span>
                </a>
              </div>
            </div>
            <p
              data-aos="zoom-in-up"
              className="text-white flex items-center space-x-3 text-[18px] sm:text-[20px]"
            >
              <SupportAgentIcon
                className="text-[#00C9DB]"
                style={{ inlineSize: "40px", blockSize: "40px" }}
              />
              <span>
                Оператор : {branchName === "Главный офис" && "107 ,112 ,113"}
                {branchName === "Ангрен Офис" && "Мадина"}
                {branchName === "Аккурган Офис" && "Иродахон, Азаматжон"}
                {branchName === "Зарафшон Офис" && "Бекзод"}
                {branchName === "Ургенч Офис" && "Ферузбек"}
                {branchName === "Aхангаран Офис" && "Saida"}
                {branchName === "Бука Офис" && "Малик , Бехруз"}
                {branchName === "Уртачирчик Офис" && "Xusniddin"}
                {branchName === "Пскент Офис" && "Xusniddin"}
                {branchName === "Олмалиқ Офис" && "Behruz"}
                {branchName === "Хазорасп Офис" && "Умарбек "}
                {branchName === "Навоий Офис" && "Нодира"}
              </span>
            </p>
          </div>
          {branchName === "Главный офис" && (
            <iframe
              title="Главный офис"
              className="rounded-md w-[90%] xl:w-[33%]"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1498.982340543853!2d69.26070649111738!3d41.28787313458078!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38ae8bb2ac239901%3A0x61c0666992e246b5!2sCashbox.uz!5e0!3m2!1sru!2s!4v1686310978424!5m2!1sru!2s"
              width="600"
              height="450"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          )}
          {branchName === "Ангрен Офис" && (
            <iframe
              title="Ангрен Офис"
              className="rounded-md w-[90%]  xl:w-[33%]"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d188.14500829926192!2d70.08181702361065!3d41.01825160535971!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38afe991bf6bc80f%3A0xb3709465b8b961b1!2zMjM5Sis4UEcsINCQ0L3Qs9GA0LXQvSwg0KPQt9Cx0LXQutC40YHRgtCw0L0!5e0!3m2!1sru!2sus!4v1686582318022!5m2!1sru!2sus"
              width="600"
              height="450"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          )}
          {branchName === "Аккурган Офис" && (
            <iframe
              title="Аккурган Офис"
              className="rounded-md w-[90%] xl:w-[33%]"
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d754.1534728924751!2d69.04630510841828!3d40.8803468373475!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDDCsDUyJzQ5LjEiTiA2OcKwMDInNDcuOSJF!5e0!3m2!1sru!2s!4v1686497845962!5m2!1sru!2s"
              width="600"
              height="450"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          )}
          {branchName === "Зарафшон Офис" && (
            <iframe
              title="Зарафшон Офис"
              className="rounded-md w-[90%] xl:w-[33%]"
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d7099.6123923569!2d64.19541746882253!3d41.56882678236694!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDHCsDM0JzA3LjYiTiA2NMKwMTEnNDQuOSJF!5e0!3m2!1sru!2s!4v1687190354609!5m2!1sru!2s"
              width="600"
              height="450"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          )}
          {branchName === "Ургенч Офис" && (
            <iframe
              title="Ургенч Офис"
              className="rounded-md w-[90%] xl:w-[33%]"
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d373.20664649853296!2d60.63370231763384!3d41.555106197897054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDHCsDMzJzE4LjciTiA2MMKwMzgnMDEuNSJF!5e0!3m2!1sru!2s!4v1687189937906!5m2!1sru!2s"
              width="600"
              height="450"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          )}
          {branchName === "Aхангаран Офис" && (
            // eslint-disable-next-line jsx-a11y/iframe-has-title
            <iframe
              className="rounded-md w-[90%] xl:w-[33%]"
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2226.302399761564!2d69.6451666243537!3d40.903384464127505!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDDCsDU0JzEwLjciTiA2OcKwMzgnNDguNSJF!5e0!3m2!1sru!2s!4v1689580745848!5m2!1sru!2s"
              width="600"
              height="450"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          )}
          {branchName === "Бука Офис" && (
            // eslint-disable-next-line jsx-a11y/iframe-has-title
            <iframe
              className="rounded-md w-[90%] xl:w-[33%]"
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d1493.52325213844!2d69.1985598569176!3d40.81537209243381!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDDCsDQ4JzUyLjgiTiA2OcKwMTEnNTkuNyJF!5e0!3m2!1sru!2s!4v1689581405716!5m2!1sru!2s"
              width="600"
              height="450"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          )}
          {branchName === "Уртачирчик Офис" && (
            // eslint-disable-next-line jsx-a11y/iframe-has-title
            <iframe
              className="rounded-md w-[90%] xl:w-[33%]"
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3009.5244016652714!2d69.35606007581909!3d41.035659971346725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDHCsDAyJzA4LjQiTiA2OcKwMjEnMzEuMSJF!5e0!3m2!1sru!2s!4v1689582143583!5m2!1sru!2s"
              width="600"
              height="450"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          )}
          {branchName === "Пскент Офис" && (
            // eslint-disable-next-line jsx-a11y/iframe-has-title
            <iframe className="rounded-md w-[90%] xl:w-[33%]" src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d753.9398508214858!2d69.35241571219206!3d40.8990923010251!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDDCsDUzJzU3LjIiTiA2OcKwMjEnMTAuMSJF!5e0!3m2!1sru!2s!4v1689686327775!5m2!1sru!2s" width="600" height="450" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
          )}
          {branchName === "Хазорасп Офис" && (
            // eslint-disable-next-line jsx-a11y/iframe-has-title
            <iframe className="rounded-md w-[100%] xl:w-[33%]" src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d1498.2446075873188!2d61.06735609770848!3d41.31997422717841!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDHCsDE5JzE0LjMiTiA2McKwMDQnMDQuNSJF!5e0!3m2!1sru!2s!4v1689847706785!5m2!1sru!2s" width="600" height="450" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
          )}
          {branchName === "Навоий Офис" && (
            // eslint-disable-next-line jsx-a11y/iframe-has-title
            <iframe className="rounded-md w-[100%] xl:w-[33%]" src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d865.3748449567175!2d65.37807965939254!3d40.10601859780948!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDDCsDA2JzIxLjMiTiA2NcKwMjInNDIuOSJF!5e0!3m2!1sru!2s!4v1705474235690!5m2!1sru!2s" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          )}
        </div>
      </div>
      <Footer bg={true} />
      <a href={'#branchs'} className='w-[42px] z-50 rotate-90 duration-200 fixed right-5 bottom-5 h-[42px] text-white flex items-center justify-center rounded-[50%] bg-[#00C9DB] hover:bg-[#73e5f0]'>
        <ArrowBackIosNewIcon />
      </a>
    </div>
  );
}

export default Branchs;
